import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconPlanetakeOff: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.8999 6.69999C18.9999 6.19999 20.2999 6.39999 21.1999 7.29999C21.7999 7.99999 22.0999 8.89999 21.9999 9.89999C21.7999 10.8 21.0999 11.6 20.1999 12L8.49992 16.1C8.09992 16.2 7.59992 16.3 7.19992 16.3C5.89992 16.3 4.49992 15.6 3.79992 14.4L2.09992 11.5C1.99992 11.3 1.89992 10.9 1.99992 10.7C2.09992 10.5 2.29992 10.2 2.59992 10.1L4.59992 9.09999C4.89992 8.89999 5.39992 8.99999 5.69992 9.29999L7.19992 10.8L8.09992 10.3L4.19992 5.59999C3.99992 5.39999 3.99992 5.09999 3.99992 4.79999C4.09992 4.49999 4.29992 4.19999 4.59992 4.09999L6.59992 3.09999C6.89992 2.99999 7.19992 2.99999 7.49992 3.19999L14.8999 7.79999L17.8999 6.69999ZM7.99992 14.2L19.4999 10.1C19.6999 9.99999 19.8999 9.79999 19.9999 9.49999C19.9999 9.19999 19.9999 8.89999 19.7999 8.79999C19.5999 8.49999 19.0999 8.39999 18.7999 8.59999H18.6999L15.1999 9.79999C14.8999 9.89999 14.5999 9.89999 14.2999 9.69999L6.99992 5.09999L6.59992 5.29999L10.4999 10.1C10.6999 10.3 10.7999 10.6 10.6999 10.9C10.6999 11.2 10.4999 11.5 10.1999 11.6L8.09992 12.6C7.29992 13 6.39992 12.8 5.79992 12.1L4.79992 11.1L4.39992 11.3L5.59992 13.3C6.09992 14.2 7.09992 14.5 7.99992 14.2ZM4.99988 19H18.9999C19.5999 19 19.9999 19.4 19.9999 20C19.9999 20.6 19.5999 21 18.9999 21H4.99988C4.39988 21 3.99988 20.6 3.99988 20C3.99988 19.4 4.39988 19 4.99988 19Z',
    })
  )
}
